import {
  FETCH_TYPEUSERS_REQUEST,
  FETCH_TYPEUSERS_SUCCESS,
  FETCH_TYPEUSERS_FAILURE
} from "./typeUserActions";

const initialState = {
  loading: false,
  typeUsers: [],
  error: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TYPEUSERS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_TYPEUSERS_SUCCESS:
      return {
        loading: false,
        typeUsers: action.payload,
        error: ""
      };
    case FETCH_TYPEUSERS_FAILURE:
      return {
        loading: false,
        typeUsers: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
